import { ORPCError } from "@orpc/client";

export function resolveInviteErrorToastKey(error: unknown, fallbackKey: string): string {
    if (error instanceof ORPCError) {
        if (error.code === "INVITE_RECENTLY_SENT") {
            return "inviteRecentlySentToast";
        }
        if (error.code === "NO_INVITABLE_PRODUCT") {
            return "noInvitableProductToast";
        }
    }

    return fallbackKey;
}
